export const backendConstants = {
    BACKEND_ROOT_URL: 'https://sing-uat.i-alert.rocks/api/v1/',
    SPRING_ROOT_URL: 'https://sing-uat.i-alert.rocks/api/v2/',
    FE_ROOT_URL: 'https://sing-uat.i-alert.rocks/',
    FE_ROOT_SINGLE_SPA_URL: 'https://sing-uat.i-alert.rocks/assets/single-spa-react/dist/ITT-single-spa-react.js',
    FE_SUBFOLDER: ''
}